module.exports = __webpack_public_path__ + "static/media/beer_can_opening.51d66224.mp3";